import React from 'react'
import classes from '../StatisticsPage.module.scss'
import activityTypeIcons from '../../../definitions/activityTypeIcons'
import activityTypeColors from '../../../definitions/activityTypeColors.json'

const ActivityTypes = (props) => {
  const { data } = props

  return (
    <div className={classes.table}>
      {
        data.map(({ meta }, index) => {
          const ActivityTypeIcon = activityTypeIcons[meta.id]
          const activityTypeColor = activityTypeColors[meta.id]
          const key = `AgeGroups__data__${index}`
          return (
            <div key={key} className={classes.row}>
              <div>
                <ActivityTypeIcon fill={activityTypeColor} style={{ marginRight: '8px' }}/>
                {meta.name}
              </div>
              <div>{meta.value}</div>
            </div>
          )
        })
      }
    </div>
  )
}

export default ActivityTypes
